import { formatDistanceToNow } from 'date-fns'
import React from 'react'
import { GeckoEntry } from 'types'

import {
  ResultDescription,
  ResultHeader,
  ResultItemContainer,
  ResultMeta,
  ResultTitle,
  ResultType,
} from './ResultCardStyles'

export interface ResultCardProps {
  entry: GeckoEntry
  onClick?: (entry: GeckoEntry) => void
}

export const getEntryDisplayName = (entry: GeckoEntry): string => {
  const data = entry.data as Record<string, unknown>
  return (data.name as string) || (data.title as string) || entry.id
}

export const getEntryDescription = (entry: GeckoEntry): string | undefined => {
  const data = entry.data as Record<string, unknown>
  return data.description as string | undefined
}

const formatType = (type: string): string => {
  return type.replace(/-/g, ' ')
}

export const DefaultResultCard: React.FC<ResultCardProps> = ({
  entry,
  onClick,
}) => {
  const displayName = getEntryDisplayName(entry)
  const description = getEntryDescription(entry)
  const formattedType = formatType(entry.type)

  const handleClick = () => {
    onClick?.(entry)
  }

  const timeAgo = formatDistanceToNow(new Date(entry.updated_at), {
    addSuffix: true,
  })

  return (
    <ResultItemContainer onClick={handleClick}>
      <ResultHeader>
        <ResultTitle>{displayName}</ResultTitle>
        <ResultType>{formattedType}</ResultType>
      </ResultHeader>
      <ResultMeta>
        <span>Updated {timeAgo}</span>
      </ResultMeta>
      {description && <ResultDescription>{description}</ResultDescription>}
    </ResultItemContainer>
  )
}
